// Library Class
import * as $ from 'jquery';
import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, AfterViewInit, OnDestroy } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from '../../../common/components/confirm-dialog/confirm-dialog.component';
// Class
import { MasterConstants } from '../../../common/constants/master-constants';
import { FilterOption } from '../../../common/components/filter/filter-model';
import { ControlType } from '../../../common/components/filter/filter-enum';
import { CommonService } from './../../../services/common/common.service';
import { ContainerReturnService } from '../../../services/container-return/container-return.service';
import { LocalStorageService } from '../../../services/infrastructure/local-storage.service';
import { OTIOrderLandingFilterVM } from '../../../models/OTI/OTIOrderLandingFilterVM';
import { OtiService } from '../../../services/oti/oti.service';
// Service Class
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { ExcelService } from './../../../services/infrastructure/excel.service';
// Model Class
import { ContainerReturnLandingFilterVM } from '../../../models/ContainerReturns/ContainerReturnLandingFilterVM';
import { DashboardFilter } from '../../../models/DashboardFilter';
import { BroadcastService } from '../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../services/infrastructure/config.service';

@Component({
  selector: 'app-container-returns-dashboard',
  templateUrl: './container-returns-dashboard.component.html',
  styleUrls: ['./container-returns-dashboard.component.scss']
})
export class ContainerReturnsDashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  headerCompany = MasterConstants.US_COMPANYCODE;
  headerYear: any;
  filters: OTIOrderLandingFilterVM = new OTIOrderLandingFilterVM();
  validateEvolveData: any;
  ddlAccounts: any[] = [];
  userMenuAccessList: any;
  readOnlyAccess = false;
  filterOptionsData: Array<FilterOption>;
  subscription = new Subscription();

  bannerMessage = '';
  selectedTabIndex = 0;
  masterConstants = MasterConstants;
  draftRequestDataSource: MatTableDataSource<any>;
  returnRequestDataSource: MatTableDataSource<any>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('returnRequestTable', { read: MatSort }) returnRequestSort: MatSort;
  @ViewChild('returnRequestPaginator', { read: MatPaginator }) returnRequestPaginator: MatPaginator;
  @ViewChild('returnRequestDraftTable', { read: MatSort }) returnRequestDraftSort: MatSort;
  @ViewChild('returnRequestDraftPaginator', { read: MatPaginator }) returnRequestDraftPaginator: MatPaginator;
  notificationList: any = [{ 'id': 'Comments', 'value': 'Comments' }, { 'id': 'ManualProducts', 'value': 'Manual Products' }, { 'id': 'Error', 'value': 'Error' }];
  draftContainerList: any = [];
  containerList: any = [];
  returnRequestColumns: string[] = [];
  returnRequestDraftColumns: string[] = [];
  filter: ContainerReturnLandingFilterVM = new ContainerReturnLandingFilterVM();
  returnRequestList: any = [];
  returnRequestDraftList: any = [];
  tabNode = false;
  totalNumbersOfOrder = 0;
  totalnumbersOfProduct = 0;
  totalOrderCost = 0;
  deliverToAccountdetails: any = {};
  soldToAccountdetails: any = {};

  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private localStorageService: LocalStorageService,
    private containerReturnService: ContainerReturnService,
    private matDialog: MatDialog,
    private toastrService: ToastrService,
    public excelService: ExcelService,
    private datePipe: DatePipe,
    private commonService: CommonService,
    private otiService: OtiService
  ) { }

  // Create a new Container order(navigate to new order screen)
  createNewReturn() {
    this.router.navigate(['/container-returns/request-products/']);
  }

  // ngOnInit
  ngOnInit() {
    this.readOnlyAccess = this.commonService.checkUserRoleAccessType(MasterConstants.FUNCTION_CODE.COI_ORDER);

    this.getBannerMessage();
    this.setFilterAndGridColumn();
    this.setDropDownValues();
    this.setDefaultFilter();
    this.getGridData();
  }

  // Get Banner Message
  getBannerMessage() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.containerReturnService.getBannerMessage().subscribe((result: any) => {
      this.bannerMessage = result.message;
      this.loaderService.setLoaderStatus(false);
    }, error => {
      this.loaderService.setLoaderStatus(false);
    }));
  }

  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccSummaryTableHeight();
  }

  // Tab changed
  tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
    this.selectedTabIndex = tabChangeEvent.index;
    this.setAccSummaryTableHeight();
  };

  // set account table height
  setAccSummaryTableHeight() {
    setTimeout(function () {
      const templateHeight = window.innerHeight - $('.TopSec').outerHeight() - $('.form-sec').outerHeight() - $('.mat-mdc-tab-header').outerHeight() - $('.fulfill-top-sec').outerHeight() - 200;
      $('.activeReturnRequest').css('max-height', templateHeight + 'px');
      $('.draftReturnRequest').css('max-height', templateHeight + 'px');
    }, 100);
  }

  // Set Filter and Grid Columns
  setFilterAndGridColumn() {
    this.filterOptionsData = [
      { label: 'Account Name', key: 'accountName', controlType: ControlType.Text },
      { label: 'Account No', key: 'accountNo', controlType: ControlType.Text },
      { label: 'Item Number', key: 'itemNo', controlType: ControlType.DropDown, controlDataBindLabel: 'value', controlDataBindValue: 'value' },
      { label: 'Lot/Serial Number', key: 'lotSerialNo', controlType: ControlType.Text },
      { label: 'Product Name', key: 'productName', controlType: ControlType.Text },
      { label: 'Request Date', key: 'requestDate', controlType: ControlType.DateRange },
      { label: 'Return Id', key: 'returnId', controlType: ControlType.Text },
      { label: 'Customer PO #', key: 'customerPO', controlType: ControlType.Text },
    ];

    this.returnRequestColumns = ['returnRequestNumber', 'accountName', 'accountNumber', 'purchaseOrderNumber', 'orderCreateDate', 'status', 'contextMenu'];
    this.returnRequestDraftColumns = ['returnRequestNumber', 'accountName', 'accountNumber', 'purchaseOrderNumber', 'orderCreateDate', 'contextMenu'];
  }

  // Set Drop down values for filter
  setDropDownValues() {
    if (this.localStorageService.get(MasterConstants.CONTAINER_RETURN_ITEM_NUMBER_MASTER_LIST)) {
      this.filterOptionsData.find(x => x.key === 'itemNo').controlData = JSON.parse(this.localStorageService.get(MasterConstants.CONTAINER_RETURN_ITEM_NUMBER_MASTER_LIST));
    }
    else {
      this.subscription.add(this.containerReturnService.getItemNumberList().subscribe((result: any[]) => {
        this.localStorageService.set(MasterConstants.CONTAINER_RETURN_ITEM_NUMBER_MASTER_LIST, JSON.stringify(result));
        this.filterOptionsData.find(x => x.key === 'itemNo').controlData = JSON.parse(this.localStorageService.get(MasterConstants.CONTAINER_RETURN_ITEM_NUMBER_MASTER_LIST));
      }));
    }
  }

  // Set default filter values
  setDefaultFilter() {
    this.filter = {
      accountName: null,
      accountNo: null,
      itemNo: null,
      lotSerialNo: null,
      productName: null,
      requestDate: null,
      returnId: null,
      customerPO: null
    };
  }

  // get text from status
  public getStatusText(status: string): string {
    status = status.toUpperCase();
    let retVal = status;
    if (status === 'ACCEPTED') {
      retVal = 'SUBMITTED';
    } else if (status === 'PLANNING' || status === 'SHIPPED') {
      retVal = 'APPROVED';
    }
    return retVal;
  }

  // ngOnDestroy
  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  // get data for both tabs
  getGridData() {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.containerReturnService.getContainerReturnRequestList(this.filter).subscribe((result: any[]) => {
      // Active tab variables.
      this.returnRequestList = result.filter(x => x.status !== 'DRAFT');
      this.returnRequestDataSource = new MatTableDataSource(this.returnRequestList);
      this.returnRequestDataSource.paginator = this.returnRequestPaginator;
      this.returnRequestDataSource.paginator.firstPage();
      this.returnRequestDataSource.sort = this.returnRequestSort;

      // Draft tab variables.
      this.returnRequestDraftList = result.filter(x => x.status === 'DRAFT');
      this.draftRequestDataSource = new MatTableDataSource(this.returnRequestDraftList);
      this.draftRequestDataSource.paginator = this.returnRequestDraftPaginator;
      this.draftRequestDataSource.paginator.firstPage();
      this.draftRequestDataSource.sort = this.returnRequestDraftSort;

      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); }));
  }

  // Search Action
  filterSearchClick(event) {
    this.filter = event;
    this.getGridData();
  }

  // Clear All Action
  filterClearAllClick(event) {
    this.filter = event;
    this.getGridData();
  }

  // Navigate to selected order detail
  navigateOrderDetail(obj: any, tabType: string) {
    const accountNumber = 0;
    if (obj) {
      this.loaderService.setLoaderStatus(true);
      this.containerReturnService.setReturnRequestStatus(obj.status);
      this.containerReturnService.setContainerReturnRequestId(+obj.containerReturnRequestId);
      if (tabType == 'active') {
        this.router.navigate(['/container-returns/products-confirmation', obj.containerReturnRequestId]);
      } else {
        this.router.navigate(['/container-returns/request-products', obj.containerReturnRequestId]);
      }
      this.loaderService.setLoaderStatus(false);
    }
  }

  // Delete draft request
  deleteOrder(order: any) {
    if (order) {
      const dialogRef = this.matDialog.open(ConfirmDialogComponent, {
        disableClose: true,
        width: '400px',
        data: { title: 'Delete Draft Request', message: 'Do you want to delete this saved request?', labelYes: 'Yes', labelNo: 'No', dialogType: 'confirm' }
      });

      this.subscription.add(dialogRef.afterClosed().subscribe(result => {
        // If user selected Yes
        if (result == true) {
          this.loaderService.setLoaderStatus(true);
          this.subscription.add(this.containerReturnService.deleteRequest(order.containerReturnRequestId).subscribe(result => {
            if (result) {
              this.toastrService.success('Draft order deleted successfully.');
              this.getGridData();
            }
            this.loaderService.setLoaderStatus(false);
          }, error => this.loaderService.setLoaderStatus(false)));
        }
      }));
    }
  }

  // navigate to Order To Invoice page
  viewOrderToInvoice(element) {
    this.loaderService.setLoaderStatus(true);
    this.subscription.add(this.containerReturnService.checkOTIOrders(element.accountNumber, element.purchaseOrderNumber).subscribe(result => {
      if (result) {
        //this.localStorageService.set(MasterConstants.OTI_CUSTOMERPO, element.purchaseOrderNumber);
        //this.localStorageService.set(MasterConstants.OTI_ACCOUNTNUMBER, element.accountNumber);
        //this.router.navigate(['/cc/landing-data']);
        this.filters.account = element.accountNumber;
        this.filters.dateInDays = 0;
        this.filters.fromOrderDate = element.orderCreateDate !== null ? new Date(element.orderCreateDate) : null;
        this.filters.toOrderDate = new Date();
        this.filters.customerPO = element.purchaseOrderNumber;
        this.filters.orderStatus = null;
        this.filters.orderStatusText = "ALL";
        this.filters.productLineSegment = 'CPP';
        this.filters.dateRangeText = this.filters.fromOrderDate != null && this.filters.toOrderDate != null ? this.datePipe.transform(this.filters.fromOrderDate, 'MM/dd/yyyy')
          + ' - ' + this.datePipe.transform(this.filters.toOrderDate, 'MM/dd/yyyy') : "";
        this.otiService.setFilters(this.filters);
        this.router.navigate(['/order/dashboard']);
      } else {
        this.toastrService.error('Order not found. Please check back.');
      }
      this.loaderService.setLoaderStatus(false);
    }, error => this.loaderService.setLoaderStatus(false)));
  }

  // export data to excel
  public export() {
    this.loaderService.setLoaderStatus(true);

    if (this.selectedTabIndex === 0 && this.returnRequestList && this.returnRequestList.length > 0) {
      this.subscription.add(this.containerReturnService.getReturnRequestReport(this.filter).subscribe((result: any[]) => {
        const exportData = [];
        if (result && result.length > 0) {
          this.loaderService.setLoaderStatus(true);
          result.filter(x => x.status !== 'DRAFT').forEach(x => {
            exportData.push({
              'Return Number': x.returnRequestNumber,
              'Account Name': x.accountName,
              'Account#': x.accountNumber,
              'Account Address': x.accountAddress1,
              'Account City': x.accountCity,
              'Return Type': x.returnType,
              'Customer PO#': x.purchaseOrderNumber,
              'Request Date': this.datePipe.transform(x.orderCreateDate, MasterConstants.DATE_MMDDYYYY),
              'Status': x.status,
              'Item Number': x.itemNumber,
              'Item Description': x.productName,
              'Lot - Serial Number': x.lotSerialNumber,
              'Return Units': x.returnUnits,
              'Order UOM': x.orderUOM
            });
          });
          this.excelService.exportAsExcelFile(exportData, 'ActiveContainerReturns');
          this.loaderService.setLoaderStatus(false);
        }
      }));
    } else if (this.selectedTabIndex === 1 && this.returnRequestDraftList && this.returnRequestDraftList.length > 0) {
      this.subscription.add(this.containerReturnService.getReturnRequestReport(this.filter).subscribe((result: any[]) => {
        const exportData = [];
        if (result && result.length > 0) {
          this.loaderService.setLoaderStatus(true);
          result.filter(x => x.status === 'DRAFT').forEach(x => {
            exportData.push({
              'Return Number': x.returnRequestNumber,
              'Account Name': x.accountName,
              'Account#': x.accountNumber,
              'Account Address': x.accountAddress1,
              'Account City': x.accountCity,
              'Return Type': x.returnType,
              'Customer PO#': x.purchaseOrderNumber,
              'Request Date': this.datePipe.transform(x.orderCreateDate, MasterConstants.DATE_MMDDYYYY),
              'Status': x.status,
              'Item Number': x.itemNumber,
              'Item Description': x.productName,
              'Lot - Serial Number': x.lotSerialNumber,
              'Return Units': x.returnUnits,
              'Order UOM': x.orderUOM
            });
          });
          this.excelService.exportAsExcelFile(exportData, 'DraftsContainerReturns');
          this.loaderService.setLoaderStatus(false);
        }
      }));
    }
  }
}
